import { lazy } from "react";
import { Navigate, Route, Routes as RR } from "react-router-dom";

import { ProtectedRoute } from "./shared/auth/ProtectedRoute";
import { RoleRedirect } from "./shared/auth/RoleRedirect";

const LoginPage = lazy(() => import("./areas/login/LoginPage"));
const RegistroChooserPage = lazy(() => import("./areas/registro/RegistroChooserPage"));
const RegistroAtletaPage = lazy(() => import("./areas/registro/RegistroAtletaPage"));
const RegistroResponsavelPage = lazy(() => import("./areas/registro/RegistroResponsavelPage"));
const RegistroOficialPage = lazy(() => import("./areas/registro/RegistroOficialPage"));
const PoliticaPrivacidadePage = lazy(() => import("./areas/lgpd/PoliticaPrivacidadePage"));

const AdminDashboard = lazy(() => import("./areas/admin/AdminDashboard"));
const FederacaoDashboard = lazy(() => import("./areas/federacao/FederacaoDashboard"));
const ClubeDashboard = lazy(() => import("./areas/clube/ClubeDashboard"));
const ResponsavelDashboard = lazy(() => import("./areas/responsavel/ResponsavelDashboard"));
const AtletaDashboard = lazy(() => import("./areas/atleta/AtletaDashboard"));
const OficialDashboard = lazy(() => import("./areas/oficial/OficialDashboard"));
const PlayerPage = lazy(() => import("./areas/player/PlayerPage"));
const PainelDashboard = lazy(() => import("./areas/painel/PainelDashboard"));
const ObsScorePage = lazy(() => import("./areas/obs/ObsScorePage"));
const ObsRankingPage = lazy(() => import("./areas/obs/ObsRankingPage"));
const ObsIntroPage = lazy(() => import("./areas/obs/ObsIntroPage"));
const ObsNotaPage = lazy(() => import("./areas/obs/ObsNotaPage"));
const PrimeiroAcessoPage = lazy(() => import("./areas/primeiro-acesso/PrimeiroAcessoPage"));

export function Routes() {
  return (
    <RR>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegistroChooserPage />} />
      <Route path="/registro/atleta" element={<RegistroAtletaPage />} />
      <Route path="/registro/responsavel" element={<RegistroResponsavelPage />} />
      <Route path="/registro/oficial" element={<RegistroOficialPage />} />
      <Route path="/politica-privacidade" element={<PoliticaPrivacidadePage />} />

      <Route path="/" element={<RoleRedirect />} />

      {/* Telas OBS: públicas, autenticadas pelo display-token do segmento (?t=). */}
      <Route path="/obs/score/:segmentoId" element={<ObsScorePage />} />
      <Route path="/obs/ranking/:segmentoId" element={<ObsRankingPage />} />
      <Route path="/obs/intro/:segmentoId" element={<ObsIntroPage />} />
      <Route path="/obs/nota/:segmentoId" element={<ObsNotaPage />} />

      <Route
        path="/primeiro-acesso"
        element={
          <ProtectedRoute allow={["admin_federacao", "usuario_clube", "atleta", "responsavel", "oficial"]} bypassOnboarding>
            <PrimeiroAcessoPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allow={["admin_global"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/federacao/*"
        element={
          <ProtectedRoute allow={["admin_global", "admin_federacao"]}>
            <FederacaoDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clube/*"
        element={
          <ProtectedRoute allow={["admin_global", "admin_federacao", "usuario_clube"]}>
            <ClubeDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/responsavel/*"
        element={
          <ProtectedRoute allow={["responsavel"]}>
            <ResponsavelDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/atleta/*"
        element={
          <ProtectedRoute allow={["atleta"]}>
            <AtletaDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/oficial/*"
        element={
          <ProtectedRoute allow={["oficial"]}>
            <OficialDashboard />
          </ProtectedRoute>
        }
      />
      {/* Painéis ao vivo da pontuação: qualquer conta com badge de oficial escalada (ou gestor). */}
      <Route
        path="/painel/*"
        element={
          <ProtectedRoute allow={["admin_global", "admin_federacao", "usuario_clube", "atleta", "oficial", "responsavel"]} bypassOnboarding>
            <PainelDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/player/:eventoId/:dia"
        element={
          <ProtectedRoute allow={["admin_global", "admin_federacao", "usuario_clube"]}>
            <PlayerPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </RR>
  );
}
